// Backend CustomException responses have the shape { error_code, message, reference_id }
export const getApiErrorCode = (error) => error?.response?.data?.error_code ?? null;

export const getApiStatus = (error) => error?.response?.status ?? null;

export const isDuplicateRoleError = (error) =>
  ['ROLE__DUPLICATE', 'ROLE__ALREADY_EXISTS'].includes(getApiErrorCode(error));
